import React, { FC } from 'react';

const SuccessIcon: FC = () => (
    <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='25' cy='25' r='25' fill='#00CC99' />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M36.1784 19.5133L21.6666 34.0251L13.8214 26.1799L16.1784 23.8229L21.6666 29.3111L33.8214 17.1562L36.1784 19.5133Z'
            fill='white'
        />
    </svg>
);

export default SuccessIcon;
